import { Container, Button, ListGroup } from 'react-bootstrap';
import { NavLink, Link, useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './AdmManualsInstruct.css';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import editIco from "../../lib/img/edit.png";
import deleteIco from "../../lib/img/deleteIco.png";
// import addIco from "../../lib/img/addIco.png";
import AddFileModal from "./AdminModals/addFile";
import EditFileModal from "./AdminModals/editFile";
import { getAllInstructManual, loadFilesContent, deleteOneFile, editOneFile } from "../../services/RequestsToServer";


function AdminManualsInstructions() {
    const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null); 
    const [fileToModal, setFileToModal] = useState(null);
    const [directoryType, setDirectoryType] = useState(true);
    const [zoom, setZoom] = useState(1);
    const [error, setError] = useState(null);
    const [fileToEdit, setFileToEdit] = useState(null);
    const history = useHistory();

    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const handleClose = () => {
      setShowAddModal(false);
    };
    const handleShow = () => setShowAddModal(true);

    const handleCloseEdit = () => setShowEditModal(false);
    const handleShowEdit = (file) => {
    setFileToEdit(file);
    setShowEditModal(true);
  };

     // Завантаження списку файлів із бекенду
    useEffect(() => {
        const fetchFiles = async () => {
        try {
            const response = await getAllInstructManual();
            if(response.status === 200) {
              setFiles(response.data);
              setError(null);
            } else {
              setError(response);
            }
        } catch (error) {
            console.error('Error:', error);
        }
        };
        fetchFiles();
    }, []);

    const addFile = (newFile) => {
        setFiles([...files, newFile]);
    };

      const loadFileContent = (file) => {
        const obj = loadFilesContent(file);
        if (typeof obj === "object" && obj !== null) {
        // Скидаємо selectedFile перед встановленням нового, щоб змусити оновлення
            setSelectedFile(null);
          setTimeout(() => {
            setSelectedFile(obj);
          }, 0);
        } else {
          setError(String(obj));
        }
      };

  const deleteFile = async (id) => {
      try {
        const deleteAnsw = await deleteOneFile(id);
        
        if(deleteAnsw.status === 200) {
        // Оновлення стану: видаляємо файл із масиву
          setFiles(files.filter((file) => file.id !== id));
          setError(null);
          setSelectedFile(null);
          setFileToModal(null);
        } else {
          setError(String(deleteAnsw));
        }
        
      } catch (error) {
        console.error('Error deleting file:', error);
      }
    };

    const editFile = async (updatedFile) => {
    try {
      const editAnsw = await editOneFile(updatedFile);
      if(editAnsw.status === 200) {
      // Оновлення стану: замінюємо старий файл на оновлений
        setFiles(files.map((file) => (file.id === updatedFile.id ? editAnsw.data : file)));
        setError(null);
      }
      else {
        setError(String(editAnsw));
      }
    } catch (error) {
      console.error('Error editing file:', error);
    }
  };
    
  return (
    <Container className='AdminManualsInstructionsWrapper'>
        {error && <div className="alert alert-danger">{error}</div>}
        <div className='titleBtnInstructWrapper'>
            <h5 className='titleContainerInstructAdmStyle'>Інструкції та посібники</h5>
            <Button className='btn btn-secondary btnAddInstructionsAdm' onClick={handleShow}>Додати</Button>
        </div>
        {/* <hr></hr> */}
        <Row>
            <Col className='mb-2'>
            {/* <img src={addIco} className='icoAddStyle' onClick={handleShow}/> */}
            <div className='wrapperSpan'>
            <span className={`styleSpanTab InstructionsSpan ${directoryType ? "spanActive" : ""}`} onClick={()=>{setDirectoryType(true); setFileToModal(null); setSelectedFile(null);}}>Інструкції</span>
            <span className={`styleSpanTab ManualsSpan ${!directoryType ? "spanActive" : ""}`} onClick={()=>{setDirectoryType(false); setFileToModal(null); setSelectedFile(null);}}>Посібники</span>
            {fileToModal ? 
                <>
                <img src={editIco} className='edit-ico' onClick={() => handleShowEdit(fileToModal)}/>
                <img
                  src={deleteIco}
                  alt="Delete"
                  className="delete-icon"
                  onClick={() => deleteFile(fileToModal.id)}
                /> 
                </>
             : null
            }
            </div>
                {/* <Button className='btn-secondary btnAddStyle' onClick={handleShow}>Додати</Button> */}
            </Col>
        </Row>
        <Row className='row-1 row-xl-1 row-lg-1 row-md-2 row-sm-3 rowStyle'>
          {directoryType ? 
            <Col className='col-12 col-xl-3 col-lg-3 col-md-12 col-sm-12 borderRight'>
                <div className='StyleColumn'>
                    <h5 className='titleColumnStyle'>Інструкції</h5>
                    <ListGroup>
                        {files
                        .filter((file) => file.type === 'instruction')
                        .map((file) => (
                        <ListGroup.Item
                        key={file.id}
                        action
                        onClick={() => {loadFileContent(file); setFileToModal(file);}}
                        className="adm-instruction-item"
                        >
                        {file.name}
                        </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
            </Col>
            :
            <Col className='col-12 col-xl-3 col-lg-3 col-md-12 col-sm-12 borderRight'>
                <div className='StyleColumn'>
                    <h5 className='titleColumnStyle'>Посібники</h5>
                    <ListGroup>
                        {files
                        .filter((file) => file.type === 'manual')
                        .map((file) => (
                        <ListGroup.Item
                        key={file.id}
                        action
                        onClick={() => {loadFileContent(file);setFileToModal(file);}}
                        className="adm-instruction-item"
                        >
                        {file.name}
                        </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
            </Col>
          }
            <Col className='col-12 col-xl-9 col-lg-9 col-md-12 col-sm-12'>
                {/* <div className='StyleColumn'> */}
                    {/* <h5 className='titleColumnStyle'>Перегляд</h5> */}
                    <div className="viewer-container">
                    {selectedFile ? (
                      <DocViewer
                        key={selectedFile.timestamp || selectedFile.uri}
                        documents={[selectedFile]}
                        pluginRenderers={DocViewerRenderers}
                        className="doc-viewer-custom-Admin"
                        config={{
                        header: {
                        disableFileName: true,
                        retainURLParams: false,
                        },
                        pdfZoom: {
                        defaultZoom: zoom,
                        zoomJump: 0.2,
                        },
                        }}
                        onDocumentLoad={() => console.log('Документ завантажено')}
                        />
                        ) : (
                        'Виберіть файл зі списку'
                    )}
                    {/* </div> */}
                </div>
            </Col>
        </Row>
        <AddFileModal show={showAddModal} close={handleClose} addFile={addFile} />
        <EditFileModal
        show={showEditModal}
        close={handleCloseEdit}
        file={fileToEdit}
        onSave={editFile}
      />
    </Container>
  );
}

export default AdminManualsInstructions;
